import mixpanel from "mixpanel-browser";
import api from "src/utils/api";
import { variant } from "src/config";

let intercomUserId: string | null = null;

export const setIntercomIdentity = (userId?: string): void => {
  intercomUserId = userId ?? null;
};

const getAnonymousId = (): string => {
  let id = localStorage.getItem("mp_anonymous_id");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("mp_anonymous_id", id);
  }
  return id;
};

const getUserId = (): string => {
  return intercomUserId ?? getAnonymousId();
};

/* Mixpanel Service */
const initialise = (): void => {
  mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN as string);
};

const identify = async (user_id: string): Promise<void> => {
  try {
    await api.apiClient.post("/api/analytics/mixpanel/user/", {
      user_id: user_id,
    });
  } catch (error) {
    console.error("Backend Mixpanel identify failed:", error);
  }
};

const trackEvent = async (
  eventName: string,
  properties: Record<string, unknown> = {}
): Promise<void> => {
  try {
    const eventID = `${variant}_portal_${eventName}`;

    await api.apiClient.post("/api/analytics/mixpanel/event/", {
      event_name: eventID,
      user_id: getUserId(),
      properties,
    });
  } catch (error) {
    console.error("Backend Mixpanel event failed:", error);
  }
};

const reset = (): void => {
  mixpanel.reset();
  intercomUserId = null;
};

export default {
  initialise,
  identify,
  trackEvent,
  reset,
};
